import { useEffect, useState } from "react";
import Loader from "../../containers/Loader/Loader";
import { verifyLogin } from "../../services/authService";
import Login from "../Login/Login";
import { Navigate } from "react-router-dom";
import { createContext,useContext } from "react";

export const AuthContext = createContext(null);
export function useAuth(){
    return useContext(AuthContext);
}

export default function ProtectedRoutes({ children }) {
  const [status, setStatus] = useState("checking");
  const [access,setAccess]=useState(null);
  useEffect(() => {
    let mounted = true; // optional for safety

    const verify = async () => {
      try {
        console.log("Verifying login status...");
        const res = await verifyLogin();
        if (mounted) {
          if (res.data.token_status === "okay") {
            console.log("Authorized access");
            setStatus("authorized");
            setAccess(res.data.access);
          } else {
            console.log("Unauthorized access attempt");
            setStatus("unauthorized");
          }
        }
      } catch (err) {
        if (mounted) setStatus("unauthorized");
      }
    };

    verify();

    // Re-verify when auth state changes (e.g., after login clears cache)
    const onAuthChanged = () => {
      // reset to checking while we re-verify
      if (mounted) setStatus("checking");
      verify();
    };
    window.addEventListener("authChanged", onAuthChanged);

    return () => {
      mounted = false;
      window.removeEventListener("authChanged", onAuthChanged);
    }; //proper cleanup
  }, []);

  if (status === "checking") {
    return <Loader />;
  } else if (status === "unauthorized") {
    return <Navigate to="/login-page" replace />;
  } else {
    return (
        <AuthContext.Provider value={{access}}>
            {children}
        </AuthContext.Provider>
    );
  }
}
